export default __webpack_public_path__ + "static/media/ad-4.c97ed976.jpg";